import { fetch } from '../utils/request';

const { PLANS_BASE } = require('./services');

const getUrl = (path) => `${PLANS_BASE}${path}`;

export default {
  getAccounts(userId) {
    return fetch(getUrl(`/account/owners/${userId}`));
  },

  checkPermissions(owner, permissions = []) {
    return fetch(getUrl('/plan/permissions/check'), {
      query: {
        owner,
        permissions: permissions.join(','),
      },
    });
  },
};
